export default __webpack_public_path__ + "static/media/map_marker.b515917b.svg";